import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import BaseCodeAdd from "./BaseCodeAdd";
import BaseCodeEdit from "./BaseCodeEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function BaseCode() {
  const [seq, setSeq] = useState(0);
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [tcid, setTcid] = useState('');
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const token = localStorage.getItem("token");

  // 폼 데이타
  const [data, setData] = useState({
    gubun: ''
  });

  const onChangeData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const columns = [
    { field: "id", headerName: "id", hide: true },
    {
      field: "gubun",
      headerName: "구분",
      width: 200,
    },
    { field: "name", headerName: "키", width: 100, align: "center" },
    { field: "txtval", headerName: "문자", width: 300, align: "center" },
    { field: "intval", headerName: "숫자", width: 100, align: "center" },
    { field: "memo", headerName: "메모", width: 300, align: "center" },
    {
      field: "use_yn", headerName: "사용", width: 100, align: "center",
      renderCell: (params) => {
        const color = params.row.use_yn === "Y" ? "#3096F4" : "gray";
        return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
      },
    },
    {
      field: "cname",
      headerName: "센터명",
      width: 200,
    },    
  ];

  const onCloseAddPop = () => {
    setOpenAdd(false);
    load_data();
  };

  const onOpenAdd = () => {
    setOpenAdd(true);
  };

  // 팝업 닫기
  const onCloseEditPop = () => {
    setOpenEdit(false);
    setSeq(0);
    load_data();
  };

  // 리스트
  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/basecode", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      gubun: data.gubun,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded && tcid !== '') {
      load_data();
    }
  }, [loaded, tcid]);

  // 팝업처리
  const onSearchClick = async () => {
    load_data();
  };

  // 수정모드
  useEffect(() => {
    if (seq > 0) {
      setOpenEdit(true);
    }
  }, [seq]);

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            기초코드 관리
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
            {/* 센터명 */}
            <CenterSelect
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />
            <Box sx={{ flexGrow: 1 }}></Box>

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onOpenAdd}
            >
              코드추가
            </Button>
          </Box>

          <Box display="flex" sx={{ mb: 1 }}>
            {/* 구분 */}
            <Box>
              <TextField
                sx={{ width: 120 }}
                name="gubun"
                label="구분"
                size="small"
                value={data.gubun}
                onChange={onChangeData}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            {/* <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box> */}
            <Button
              sx={{ ml: 1, fontSize: 15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
              setSeq(params.row.id);
              // setOpenEdit(true);
            }}
          />

          <Dialog
            open={openAdd}
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            onClose={() => { }}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>기초코드 추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <BaseCodeAdd
              tcid_parent = {tcid}
              login={login}
              onClosePop={onCloseAddPop}
            ></BaseCodeAdd>
          </Dialog>

          <Dialog
            open={openEdit}
            TransitionComponent={Transition}
            onClose={() => { }}
            maxWidth="sm"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>기초코드 수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <BaseCodeEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></BaseCodeEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default BaseCode;
